package com.bkahlert.hello.clickup.model.fixtures

import kotlin.time.Duration
import kotlin.time.Duration.Companion.seconds

/**
 * Duration that can be used in demos to simulate the time
 * an offloaded background process takes.
 */
public val DEMO_BASE_DELAY: Duration = 1.5.seconds
